/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

import { colors } from "../../../../../theme";
import BackButton from "../../../../../components/BackButton";

import list from "../../assets/List.svg";
import myTSquare from "../../assets/MyT-Square.svg";

const MyTSquare = () => (
    <div>
        <img
            css={css`
                width: 28px;
                height: 28px;
                display: block;
                margin-right: auto;
                @media (min-width: 481px) {
                    visibility: hidden;
                }
            `}
            src={myTSquare}
            alt="MyTutor logo"
        />
    </div>
);

const NavigationLeft = ({ currentStage }) =>
    currentStage === 0 ? <MyTSquare /> : <BackButton />;

const Title = ({ title, currentStage, numberOfStages }) => (
    <p
        css={css`
            text-align: center;
            text-transform: uppercase;
            font-weight: 800;
            color: ${colors.neutral6};
        `}
    >
        {title}
    </p>
);

const Menu = () => (
    <div>
        <img
            css={css`
                width: 24px;
                height: 24px;
                display: block;
                margin-left: auto;
            `}
            src={list}
            alt="Navigation menu icon"
        />
    </div>
);

const NavigationControls = ({ title, currentStage, numberOfStages }) => (
    <nav
        css={css`
            display: flex;
            & > * {
                flex: 1;
            }
        `}
    >
        {/*
        TODO: Enable tha back button when there will be a support for fetching already submitted data.
        <NavigationLeft currentStage={currentStage} />
        */}
        <div />
        <Title
            title={title}
            currentStage={currentStage}
            numberOfStages={numberOfStages}
        />
        <div />
    </nav>
);

export default NavigationControls;
